// scenes/DataLoader.js
import AbstractScene from './AbstractScene.js';
import { Colors } from '../consts/Colors.js';
// import { getSheetsData } from '../shared/sheetClient.js';
import allSheets from '../data/allSheets.json' assert { type: 'json' };

export function getSheetsData() {
    // On garde la même interface qu’avant (Promise)
    // console.log('[getSheetsData] Chargement depuis le JSON local');
    return Promise.resolve(allSheets);
}

export default class DataLoader extends AbstractScene {
    constructor() {
        super({ key: 'DataLoader' });
    }

    preload() {
        this._preload();
    }

    create() {
        this.createAnimation();
        const rawLang = this.game.data.lang || 'fr';
        const lang = rawLang.toLowerCase().split('-')[0];

        getSheetsData()
            .then((allSheets) => {
                const targetSheets = [
                    'Menu',
                    'Intro',
                    'Mission1',
                    'Mission2',
                    'Mission3',
                    'Mission4',
                    'End',
                    'Credits',
                ];

                // console.table(
                //     Object.entries(allSheets).map(([name, obj]) => ({
                //         sheet: name,
                //         langs: Object.keys(obj || {}).join(', '),
                //     })),
                // );

                targetSheets.forEach((s) => {
                    const sheetData = allSheets?.[s];
                    if (sheetData?.[lang]) {
                        this.game.data[`${s}Data`] = sheetData[lang];
                    } else {
                        this.game.data[`${s}Data`] = sheetData?.fr || sheetData?.en || {};
                    }
                });

                this.nextScene();
            })
            .catch((err) => {
                console.error('Erreur load données locales :', err);
                this.nextScene(); // fallback jeu sans textes
            });
    }

    createAnimation() {
        const introLogoKey =
            this.game.data.lang === 'fr'
                ? 'logo-intro'
                : this.game.data.lang === 'en'
                  ? 'logo-intro-en'
                  : 'logo-intro-default';

        this.introBack = this.add
            .rectangle(this.width / 2, this.height / 2, this.width, this.height, Colors.Elmt.White)
            .setOrigin(0.5)
            .setDepth(2);

        this.introLogo = this.add
            .image(this.width / 2, this.height / 2, introLogoKey)
            .setOrigin(0.5)
            .setScale(0.5)
            .setDepth(2);

        this.time.delayedCall(3000, () => {
            this.tweens.add({
                targets: [this.introBack, this.introLogo],
                alpha: 0,
                duration: 500,
                ease: 'Sine.easeInOut',
            });
        });
    }
}
